class LoadMore {

    constructor(ajaxURL, loadingDoneCallback, loadMoreBtnSelector, ajaxData, appendToSelector) {
        this.ajaxURL = ajaxURL;
        this.loadingDoneCallback = loadingDoneCallback;
        this.page = 1;
        this.loadingClass = 'is-loading';
        this.$loadMoreBtn = $(loadMoreBtnSelector);
        this.ajaxData = ajaxData;
        this.appendToSelector = appendToSelector;
    }

    initClickHandling() {
        this.$loadMoreBtn.on('click', this.load.bind(this));
    }

    load() {
        const self = this;
        const $postsGrid = $(this.appendToSelector);

        this.ajaxData.page = this.page + 1;
        this.$loadMoreBtn.addClass(this.loadingClass);

        jQuery.ajax({
            url: self.ajaxURL,
            type: 'post',
            data: self.ajaxData,
            dataType: 'json',
            success: function(response) {
                self.page++;

                self.$loadMoreBtn.removeClass(self.loadingClass);

                if (!response.meta.hasNext) {
                    self.$loadMoreBtn.remove();
                }

                $postsGrid.append(response.html);

                if (self.loadingDoneCallback) {
                    self.loadingDoneCallback(response);
                }
            }
        });
    }
}
